import { StaticTag } from "@dune/types";
import {
	Button,
	Card,
	CardContent,
	CardHeader,
	CardTitle,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@dune/ui";
import { ClipboardCopy } from "lucide-react";
import React from "react";

interface StaticTagsSectionProps {
	staticTags: StaticTag[];
	onCopy: (tag: string) => void;
}

const StaticTagsSection: React.FC<StaticTagsSectionProps> = ({
	staticTags,
	onCopy,
}) => {
	if (!staticTags || staticTags.length === 0) {
		return null;
	}

	return (
		<Card className="mb-6">
			<CardHeader>
				<CardTitle className="text-lg font-semibold">Tags statiques</CardTitle>
				<p className="text-sm text-gray-600">
					Ces balises peuvent être utilisées dans tous les documents et ne
					dépendent pas d'une entité spécifique.
				</p>
			</CardHeader>
			<CardContent>
				<Table>
					<TableHeader>
						<TableRow>
							<TableHead>Balise</TableHead>
							<TableHead>Libellé</TableHead>
							<TableHead>Valeur</TableHead>
							<TableHead className="w-16">Action</TableHead>
						</TableRow>
					</TableHeader>
					<TableBody>
						{staticTags.map((tag) => (
							<TableRow key={tag.key}>
								<TableCell className="font-mono text-sm max-w-xs truncate">
									{tag.key}
								</TableCell>
								<TableCell>{tag.label}</TableCell>
								<TableCell className="text-sm text-gray-600">
									{tag.value}
								</TableCell>
								<TableCell>
									<Button
										variant="ghost"
										size="icon"
										onClick={() => onCopy(`{{${tag.key}}}`)}
										title="Copier la balise statique"
									>
										<ClipboardCopy className="h-4 w-4" />
									</Button>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</CardContent>
		</Card>
	);
};

export default StaticTagsSection;
